import type { BinaryModel } from '@ctw/shared/api/fhir/models/binary';
import { DeferRendering } from '@ctw/shared/components/defer-rendering';
import { DocumentViewer } from '@ctw/shared/content/document-viewer/document-viewer';
import type { UseResourceModalOpenModalArgs } from '@ctw/shared/context/resource-modal-context';
import { tw } from '@ctw/shared/utils/tailwind';

export const binaryModalAction: UseResourceModalOpenModalArgs<'Binary'>['action'] = ({
  model,
  closeModal,
}) => ({
  label: 'Document',
  title: model.title,
  content: {
    body: <BinaryModalContent binary={model} closeModal={closeModal} />,
  },
});

interface BinaryModalContentProps {
  binary: BinaryModel;
  closeModal: () => void;
}

const BinaryModalContent = ({ binary, closeModal }: BinaryModalContentProps) => {
  return (
    <div key={binary.id} className={tw`flex h-full max-h-screen w-full flex-col items-center`}>
      <DeferRendering
        key={binary.id}
        milliseconds={500}
        message="Loading Document..."
        loadingSpinnerClassName={tw`min-h-[50vh]`}
      >
        <DocumentViewer
          binaryId={binary.id}
          onClose={closeModal}
          controls={{
            search: true,
            close: true,
            download: true,
            print: true,
            openInNewTab: true,
            deepLinkSections: true,
          }}
        />
      </DeferRendering>
    </div>
  );
};
